exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "footer{\n    width: 100%;\n    position: fixed;\n    bottom: 0;\n    background-color: #efefef;\n    padding-right: 30px;\n}\n.style_version__1jYT9{\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n}\n.style_textVersion__2fXr4{\n    color: #58666C;\n    font-size: 15px;\n    padding: 5px;\n    font-weight: 700;\n}", ""]);

// Exports
exports.locals = {
	"version": "style_version__1jYT9",
	"textVersion": "style_textVersion__2fXr4"
};